import { post } from "@/utils/axiosInstance";
import { setTimeoutExpire, setItem, getItem } from "@/utils/tokenTools";
import router from "@/router";
import { ENDPOINTS } from "../../constants";

const state = {
  token: "",
  authErrorMessage: "",
  userInfo: {
    memberType: 0,
  },
  userNumber: "",
  userCustomerId: "",
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  clearToken(state) {
    state.token = "";
  },
  setErrorMessage(state, payload) {
    state.authErrorMessage = payload;
  },
  setUserInfo(state, user) {
    state.userInfo = user;
  },
  setUserNumber(state, user) {
    state.userNumber = user;
  },
  setUserCustomerId(state, customerId) {
    state.userCustomerId = customerId;
  },
};

const actions = {
  initAuth({ commit }) {
    const token = localStorage.getItem("veri-dagitim-token");
    const getCusId = localStorage.getItem("userCusId");
    if (!token) {
      commit("setUserInfo", localStorage.getItem("username"));
      commit("setToken", token);

      if (getCusId) {
        commit("setUserCustomerId", parseInt(getCusId));
      }
    }
  },
  getMember({ commit, dispatch }, _params) {
    return new Promise((resolve) => {
      if (!_params.id) {
        dispatch("logout");
        throw new Error("id error");
      }
      post(ENDPOINTS.getMember, _params,  {}, localStorage.getItem("userId"))
        .then((response) => {
          if (response.data.error) {
            resolve(false);
          } else {
            commit("setUserInfo", response.data);
            
            if (response.data.loginInfo.memberType == 3) {
              setItem("esube", "yes");
              setItem("cusNo", response.data.customerId);
            } else {
              if(getItem("memberType") == 3){
                setItem("esube", "yes");
                setItem("cusNo", response.data.customerId);
              } else {
                setItem("esube", "no");
              }
            }

            commit("setErrorMessage", "");

            resolve(response);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  login({ commit, dispatch }, _params) {
    return new Promise((resolve) => {
      const invalidUserPasswordMsg = "Geçersiz Kullanıcı Adı veya Şifre";
      post(ENDPOINTS.login, _params)
        .then((response) => {
          if (response.data.error) {
            commit("setErrorMessage", invalidUserPasswordMsg);
            resolve(false);
          } else {
            commit("setToken", response.data.accessToken);
            setItem("veri-dagitim-token", response.data.accessToken);
            setItem("refreshToken", response.data.refreshToken);
            setItem("userId", response.data.loginInfo.id);
            setItem("cusNo", response.data.loginInfo.userName);

            setItem("username", response.data.loginInfo.name);
            if (response.data.loginInfo.memberType == 3) {
              setItem("esube", "yes");
              setItem("cusNo", response.data.customerId);
            } else {
              setItem("esube", "no");
            }

            commit("setErrorMessage", "");
            commit("setUserInfo", response.data.loginInfo);
            commit("setUserNumber", getItem("userNumber"));
            const currentTime = new Date().getTime();
            setItem("expirationDate", currentTime + response.data.expiresIn);
            setTimeoutExpire(() => dispatch("logout"));

            router.push({ name: "Home" });
            resolve(true);
          }
        })
        .catch(() => {
          commit("setErrorMessage", invalidUserPasswordMsg);
          resolve(false);
        });
    });
  },
  logout({ commit }) {
    commit("clearToken");
    localStorage.removeItem("veri-dagitim-token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expirationDate");
    localStorage.removeItem("userType");
    localStorage.removeItem("userId");
    localStorage.removeItem("cusNo");
    localStorage.removeItem("username");
    localStorage.removeItem("userNumber");

    router.push("/login").catch(() => {});
  },
};

const getters = {
  getUserInfo(state) {
    return state.userInfo;
  },
  getUserNumber(state) {
    return state.userNumber;
  },
  getToken(state) {
    return state.token;
  },
  getErrorMsg(state) {
    return state.authErrorMessage;
  },
  getUserCusId(state) {
    return state.userCustomerId;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
